import React, { useContext } from 'react';

import type { IPressRoom } from './PressRoomProvider';

const pressRoomDefault: IPressRoom = {
  pressRoom: undefined,
  newsLetterBlock: undefined,
  snsBlock: undefined,
  breadcrumpItems: undefined,
  search: undefined,
  setSearch: undefined,
  take: 0,
  setTake: undefined,
  skip: 0,
  setSkip: undefined,
  newsPagination: undefined,
  setNewsPagination: undefined,
  news: undefined,
  setNews: undefined,
  showSnsBlock: false,
  isLoading: false,
};

const PressRoomContext = React.createContext<IPressRoom>(pressRoomDefault);

const usePressRoomContext = () => useContext(PressRoomContext);

export { usePressRoomContext };

export default PressRoomContext;
